import { apiClient } from '@/lib/api/client';
import type {
  Employee,
  EmployeeFilters,
  CreateEmployeeData,
  UpdateEmployeeData,
} from '../types/employees.types';

interface ApiData<T> {
  data: T;
  message?: string;
}

interface EmployeeListResponse {
  data: Employee[];
  total: number;
  page: number;
  limit: number;
}

export const employeesService = {
  async getEmployees(companyRefId: string, filters?: EmployeeFilters): Promise<{ employees: Employee[]; total: number }> {
    const params = new URLSearchParams();
    // page and limit are required by the server
    params.set('page', String(filters?.page || 1));
    params.set('limit', String(filters?.limit || 20));

    const response = await apiClient.get<ApiData<EmployeeListResponse>>(
      `/employee/company/${companyRefId}?${params.toString()}`
    );
    return {
      employees: response.data?.data?.data ?? [],
      total: response.data?.data?.total ?? 0,
    };
  },

  async getEmployee(refId: string): Promise<Employee | null> {
    const response = await apiClient.get<ApiData<Employee>>(`/employee/${refId}`);
    return response.data?.data ?? null;
  },

  async createEmployee(data: CreateEmployeeData): Promise<Employee | null> {
    const response = await apiClient.post<ApiData<Employee>>('/employee', data);
    return response.data?.data ?? null;
  },

  async updateEmployee(data: UpdateEmployeeData): Promise<Employee | null> {
    const response = await apiClient.put<ApiData<Employee>>('/employee', data);
    return response.data?.data ?? null;
  },

  async disableEmployee(refId: string, reason?: string): Promise<void> {
    await apiClient.put(`/employee/${refId}/disable`, { reason: reason || 'Désactivé par le vendeur' });
  },

  async enableEmployee(refId: string): Promise<void> {
    await apiClient.put(`/employee/${refId}/enable`);
  },
};
